var BaseModule = require('../baseUI/baseModule');
var AccountStore = require('store/accountStore');
var AccountAction = require('action/accountAction');
var RoutePath = require('../../constants/routePath');

var translate = require('react-i18next').translate;

var ErrorApp = React.createClass({
  contextTypes: {},

  componentWillMount: function () {
    AccountStore.addChangeListener(this._onAccountChange);
  },

  componentWillUnmount: function () {
    AccountStore.removeChangeListener(this._onAccountChange);
  },

  getInitialState: function () {
    return {
      headerData: {
        module: RoutePath.ROUTE_ERROR
      },
      currentAccount: null
    }
  },

  _onAccountChange: function () {
    this.setState({
      currentAccount: AccountStore.getAccount()
    });
  },

  render: function () {
    var {t} = this.props;

    return (
      <BaseModule
        headerData={this.state.headerData}
        title={t("Error")}
      >
        {this.props.children}
      </BaseModule>
    );
  }
});

module.exports = translate(['main'], {withRef: false, wait: true})(ErrorApp);
